<template>
  <section id="electronic_billing">
    <fieldset class="fieldset">
      <legend>Validar</legend>
    <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
    <div class="columns">
      <div class="column">
        <CompanySelector v-model="company" v-validate="'required'" placeholder="Seleccione una empresa"
                name="company" @onChange="onChangeCompany" />
        <span class="show-error">{{ errors.first("company") }}</span>
      </div>
      <div class="column">
        <b-field label="Fecha inicial">
          <b-datepicker
              name="initialDate"
              v-validate="'required'"
              v-model="initialDate"
              placeholder="Seleccione una fecha..."
              icon="calendar-today"
          >
          </b-datepicker>
        </b-field>
        <span class="show-error">{{ errors.first("initialDate") }}</span>
      </div>
      <div class="column">
        <b-field label="Fecha Final">
          <b-datepicker
              name="finalDate"
              v-validate="'required'"
              v-model="finalDate"
              placeholder="Seleccione una fecha..."
              icon="calendar-today"
          >
          </b-datepicker>
        </b-field>
        <span class="show-error">{{ errors.first("finalDate") }}</span>
      </div>
      <div class="column">
        <b-field label="Tipo de Formato">
          <b-select
              name="formatType"
              v-validate="'required'"
              v-model="formatType"
              placeholder="Seleccione un tipo de archivo"
              expanded
          >
            <option
                v-for="option in documents"
                :value="option.id"
                :key="option.id"
                :id="option.id"
            >
              {{ option.name }}
            </option>
          </b-select>
        </b-field>


        <span class="show-error">{{ errors.first("formatType") }}</span>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <div class="buttons button-group">
          <b-button @click="download()" type="is-info"> Descargar</b-button>
          <b-button color="dark" @click="clearForm()" type="is-info"> limpiar</b-button>           
        </div>
      </div>
    </div>


  </fieldset>
    <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
  </section>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import {ROUTES} from "../../../../global/api_routes";
import DateUtils from '../../../../global/DateUtils';
import {configToast, TOAST_TYPES} from '../../../../global/toast'
import {confirmation} from "../../../../global/utils";
import moment from "moment"; 
import CompanySelector from "../../../../components/Shared/CompanySelector";



export default {
  name: "index",
  watch: {
    // company() {
    //   if (this.company) {
    //     this.getCalendar();
    //     return;
    //   }
    //   this.company = null;
    // },
    selectedDate() {
      const dateSend = moment(this.selectedDate).format("YYYY-MM-DD");
      this.dateSend = dateSend;
    },
  },
  components: {Treeselect , CompanySelector},
  data: () => ({
    company: null,
    isLoading:false,
    selectedFather: null,
    formatType: null,
    selected: null,
    selectedDate: null,
    dataSend: null,
    finalDate: null,
    initialDate: null,
    document: null,
    documents: [
      {name: "Excel", id: "e"},
    ],
    companies: [],

  }),
  mounted() {
    this.getCompanies();
  },
  methods: {


    clearForm() {
      this.company = null;
      this.selected = null;
      this.formatType = null;
      this.initialDate = null;
      this.finalDate = null;
    },
    onChangeCompany(company) {
      this.companyId = company.id;
    },
    toast(message, type = TOAST_TYPES.INFO) {
      const instance = configToast(this, "#electronic_billing");
      return instance.open(message, type);
    },
    getDayType(document) {
      switch (document) {

      }
    },
    getCompanies() {
      this.$http
          .get(ROUTES.DASHBOARD.GET_COMPANIES_TREE_V1, {})
          .then(({data}) => {
            if (data.code > 0) {
              this.companies = data.info;
              this.processData(this.companies);
            }
          });

    },
    processData(companies) {
      for (let index = 0; index < companies.length; index++) {
        let company = companies[index];
        company.label = company.name;
        company.id = company.code;
        if (company.children) {
          this.processData(company.children);
        }
      }
    },
    async download(){
      const validationResult = await this.$validator.validateAll();
      const validDates = DateUtils.isBefore({before: this.finalDate, date: this.initialDate})
      if (validDates){
        this.toast('Fecha final no puede ser inferior a Fecha inicial', TOAST_TYPES.ERROR);
        return;
      }
      if(!validationResult){
        this.toast('Complete el formulario', TOAST_TYPES.ERROR);
        return;
      }
      const params = {
        initial_date: DateUtils.toDateShortString({date: this.initialDate,format:"YYYY-MM-DD"}),
        final_date: DateUtils.toDateShortString({date: this.finalDate,format:"YYYY-MM-DD"}),
        company_id: this.company
      };
      console.log(params);
      this.isLoading = true;
      this.toast('Cargando Reporte', TOAST_TYPES.ERROR);
      this.$http
          .get(ROUTES.DASHBOARD.REPORTS.EASY_POINT.DOWNLOAD_REPORT, {params})
          .then(({data}) => {
            if(data.code < 0){
              this.toast(data.message, TOAST_TYPES.ERROR);
              return;
            }
            console.log(data);
            var a = document.createElement('a');
            const urlFile =  process.env.VUE_APP_URL+ROUTES.GLOBAL.DOWNLOAD_FILE+data.info;
            a.href = urlFile;
            document.body.appendChild(a);
            console.log(urlFile);
            a.download = urlFile;
            a.click();
          })
          .finally(() => {

            this.isLoading = false;


      });
    }
  }

}
</script>
<style type="scss">
.btn-save {
}


